// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { Checkbox, Popup } from 'semantic-ui-react';

interface Props {
  label: string;
  description: string;
  enabled: boolean;
  disabled?: boolean;
  disabledTooltip?: string;
  onToggle?: (next: boolean) => void;
}

/**
 * One capability toggle row. Renders a Semantic UI checkbox-as-toggle with
 * a label, sub-description, and a tooltip explaining when the toggle is
 * disabled (e.g., "Available in Phase 2").
 */
function CapabilityToggleRow({
  label,
  description,
  enabled,
  disabled = false,
  disabledTooltip,
  onToggle,
}: Props) {
  const toggle = (
    <Checkbox
      toggle
      checked={enabled}
      disabled={disabled}
      onChange={() => {
        if (!disabled && onToggle) onToggle(!enabled);
      }}
    />
  );

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        padding: '12px 0',
        borderBottom: '1px solid #eee',
      }}
    >
      <div style={{ flex: 1 }}>
        <strong>{label}</strong>
        <p style={{ margin: 0, color: '#666', fontSize: 13 }}>{description}</p>
      </div>
      {disabled && disabledTooltip ? (
        <Popup trigger={<span>{toggle}</span>} content={disabledTooltip} />
      ) : (
        toggle
      )}
    </div>
  );
}

export default CapabilityToggleRow;
